export const SUPPORT_UPLOAD_TIMEOUT_MS = 60_000;
export const SUPPORT_LOG_IPC_TIMEOUT_MS = 30_000;

export class SupportUploadTimeoutError extends Error {
  constructor(message = 'Upload timed out') {
    super(message);
    this.name = 'SupportUploadTimeoutError';
  }
}

export function withAbortTimeout<T>(
  work: (signal: AbortSignal) => Promise<T>,
  timeoutMs: number,
  timeoutMessage = 'Operation timed out',
): Promise<T> {
  const controller = new AbortController();
  let settled = false;

  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      if (settled) return;
      settled = true;
      controller.abort();
      reject(new SupportUploadTimeoutError(timeoutMessage));
    }, timeoutMs);

    work(controller.signal)
      .then((value) => {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        resolve(value);
      })
      .catch((err) => {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        if (controller.signal.aborted) {
          reject(new SupportUploadTimeoutError(timeoutMessage));
          return;
        }
        reject(err);
      });
  });
}
